import { serviceWorkerRegister } from './js/sw';

export const loadDone = (available, progressUpdate) => {
    const { body } = document;

    if (!available) {
        body.classList.add('not-available');

        return null;
    }

    const startButton = document.querySelector('.loader-start');
    const loaderBlock = document.querySelector('.page__loader');
    let startHandler;
    let enterHandler;

    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        serviceWorkerRegister();
    }

    return new Promise((resolve) => {
        const remove = () => {
            if (loaderBlock && loaderBlock.parentNode) loaderBlock.parentNode.removeChild(loaderBlock);
        };

        const hide = () => {
            if (startButton && startHandler) {
                startButton.setAttribute('disabled', 'true');
                startButton.setAttribute('aria-disabled', 'true');
                startButton.removeEventListener('click', startHandler);
            }
            if (enterHandler) window.removeEventListener('keydown', enterHandler);

            body.classList.add('loaded');
            body.classList.remove('ready');

            setTimeout(remove, 1000);
        };

        const start = () => {
            resolve();

            setTimeout(hide, 100);
        };

        startHandler = () => {
            start();
        };

        enterHandler = (evt) => {
            // Enter
            if (evt.keyCode === 13) start();
        };

        const ready = () => {
            body.classList.add('ready');

            if (startButton) {
                startButton.addEventListener('click', startHandler);
                startButton.focus();
            }
            window.addEventListener('keydown', enterHandler);

            progressUpdate(1);
        };

        progressUpdate(0.98);
        setTimeout(() => {
            progressUpdate(0.99);
        }, 300);
        setTimeout(ready, 1000);
    });
};
